import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Btn } from "@/components/erp/ui";
import { err } from "@/components/erp/flow/FlowCommon";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, BarChart, Bar } from "recharts";

const num = (n) => (n || 0).toLocaleString("id-ID");

export const SocialKpi = () => {
  const [days, setDays] = useState(30); const [d, setD] = useState(null);
  useEffect(() => { api.get(`/social/kpi?days=${days}`).then(({ data }) => setD(data)).catch(err); }, [days]);
  if (!d) return null;
  return (
    <div data-testid="kpi-page">
      <div className="flex gap-2 mb-4">{[7, 30, 90].map((n) => <Btn key={n} variant={n === days ? "primary" : "ghost"} data-testid={`kpi-days-${n}`} onClick={() => setDays(n)}>{n} hari</Btn>)}</div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="kpi-platforms">
        {d.platforms.map((p) => (
          <div key={p.platform} className="rounded-2xl border border-slate-200 bg-white p-4" data-testid={`kpi-pf-${p.platform}`}>
            <div className="text-xs text-slate-500">{p.platform} · {p.posts} post</div>
            <div className="text-2xl font-bold">{num(p.views)}</div>
            <div className="text-xs">views · {num(p.likes)} like · {num(p.comments)} komentar</div>
          </div>
        ))}
        {!d.platforms.length && <p className="text-sm text-slate-400 col-span-full" data-testid="kpi-empty">Belum ada postingan berstatus sudah diposting.</p>}
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-4 mt-4" data-testid="kpi-chart">
        <div className="font-semibold text-sm mb-2">Pertambahan views, like & komentar per hari</div>
        <div className="h-64"><ResponsiveContainer><LineChart data={d.series}><CartesianGrid strokeDasharray="3 3" stroke="#eee" /><XAxis dataKey="date" fontSize={11} /><YAxis fontSize={11} /><Tooltip /><Legend />
          <Line dataKey="views" stroke="#0f172a" strokeWidth={2} /><Line dataKey="likes" stroke="#e11d48" /><Line dataKey="comments" stroke="#0284c7" /></LineChart></ResponsiveContainer></div>
      </div>
      <div className="rounded-2xl border border-slate-200 bg-white p-4 mt-4" data-testid="kpi-top">
        <div className="font-semibold text-sm mb-2">Konten terbaik</div>
        <div className="h-56"><ResponsiveContainer><BarChart data={d.top.map((t) => ({ ...t, name: t.title.slice(0, 18) }))}><XAxis dataKey="name" fontSize={10} /><YAxis fontSize={11} /><Tooltip /><Bar dataKey="views" fill="#0f172a" /></BarChart></ResponsiveContainer></div>
        {d.top.map((t) => <div key={t.id} className="text-xs border-b border-slate-50 py-1">{t.platform} · {t.title} · {num(t.views)} views · engagement {t.engagement}%</div>)}
      </div>
      <p className="text-[11px] text-slate-400 mt-3">{d.youtube_auto ? "YouTube: angka ditarik otomatis saat refresh." : "Instagram, TikTok & YouTube: tombol refresh memperbarui info link; angka views/like/komentar dicatat tim (tanpa akses API resmi)."}</p>
    </div>
  );
};
